/*******************************************************
OPEN SCORE CARD MODAL
Used on the tournament page for PGA.
********************************************************/

import buildModal from '../../universal/modal-window/build-modal';

export default function openScoreCardModal(event) {
    const $button = $(event.currentTarget);
    const { id, firstname, lastname, round, tourneyid, playerurl } = $button.data();

    const ajaxResponse = $.ajax({
        type: 'GET',
        data: {
            round: round,
            id: id,
            tourneyid: tourneyid,
        },
        url:  '/golf/ajax/get-player-scorecard-html.php',
        timeout: 5000
    });

    ajaxResponse.fail(function(response){
        console.log('An error happened.');
    });
    
    // If the AJAX request goes through
    ajaxResponse.done(function(response){
    
        // If the response was not succesful, or there's no HTML to use, show an error notification and exit out
        if (!response.success){
            console.log('An error happened.');
            return;
        }
    
        // Build the title
        const modalTitle = `
        <div class="flex-row align-center">
            <a href="${playerurl}">${firstname} ${lastname}'s</a>&nbsp;Round ${round} Scorecard
        </div>`;

        // Build the content of the modal
        const modalContent = `
            <div id="">
                ${response.html}
            </div>`;

        // Get the modal window HTML
        const modalHTML = buildModal({
            fullWidth: true,
            title    : modalTitle,
            content  : modalContent,
        });

        // Append the modal window to the page
        $('.page').append(modalHTML);
    });

    

    

}
